import type { LooseRelationship } from '../services/metaInfoApi';

export function renderLooseFkLabel(r: LooseRelationship): string {
  if (r.sourceFilter && r.sourceFilter.length > 0) {
    const first = r.sourceFilter[0];
    const cond = first.conditions[0];
    if (cond && cond.value !== undefined && cond.value !== null) {
      return `${first.field} = ${String(cond.value)}`;
    }
    return first.field;
  }
  return `${r.toSchema}.${r.toTable}`;
}

export function looseFkHasFilter(r: LooseRelationship): boolean {
  return (r.sourceFilter?.length ?? 0) > 0 || (r.targetFilter?.length ?? 0) > 0;
}
